define( 'es6ish-class/lib/create',['require','exports','module'],function( require, exports, module ){
	return Object.create || function( obj ){
	      function F() {}
	      F.prototype = obj;
	      return new F()
    };
});
